
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M18.697 1.204a.415.415 0 0 1-.073.48C17.065 3.12 16.117 5.175 16 7.377c-.004 2.234.85 4.37 2.358 5.907a9.248 9.248 0 0 0 2.272-4.56.39.39 0 0 1 .203-.275.345.345 0 0 1 .327.01c3.625 2.165 5.862 6.277 5.84 10.73C27 25.71 22.075 31 16 31l-.112-.002C20.426 23.475 16.24 17 16.24 17c-4.825 5.8-.353 14-.353 14l-.002-.002-.169-.002C9.772 30.834 5 25.61 5 19.188c.193-8.546 5.595-15.939 13.279-18.174a.358.358 0 0 1 .418.19z","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    